import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringTrending extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/suggest/trending'
    return super.generateURL(endpoint)
  }

  updateParams() {
    this.params.set('language', 'en')
    this.params.set('limit', 4)

    super.updateParams()
  }
}

export const SearchspringTrendingProvider = generateSearchspringProvider(SearchspringTrending, (results) => {
  return {
    ...results,
    items: results.trending.queries.map((query) => ({
      query: query.searchQuery,
      label: query.searchQuery
    }))
  }
})
